import {DataGroup} from 'vis-timeline/esnext';

const Mechanics: DataGroup[] = [
    {
        id: 'mech11',
        className: 'ametras-timeline__group',
        content: 'Wolfgang Kraus',
        title: 'Monteurdetails anzeigen'
    },
    {
        id: 'mech12',
        className: 'ametras-timeline__group',
        content: 'Hans Obermüller',
        title: 'Monteurdetails anzeigen'
    },
    {
        id: 'mech21',
        className: 'ametras-timeline__group',
        content: 'Beatrice Staub',
        title: 'Monteurdetails anzeigen'
    },
    {
        id: 'mech22',
        className: 'ametras-timeline__group',
        content: 'Robert Lehmann',
        title: 'Monteurdetails anzeigen'
    },
    {
        id: 'mech23',
        className: 'ametras-timeline__group',
        content: 'Alexander Niestroy',
        title: 'Monteurdetails anzeigen'
    }
];

export { Mechanics };
